module.exports = __webpack_public_path__ + "images/MoneyBox.6f925dd5c09a7a5ad63d688c87c95c12.png";